import "./EmergencyPlumbing.module.css";
import Header from "@/reusable_sections/Header";
import EmergencyHero from "./sections/EmergencyHero";
import Overview from "./sections/Overview";
import Triage from "./sections/Triage";
import EmergencySigns from "./sections/EmergencySigns";
import Diagnostics from "./sections/Diagnostics";
import RelatedServices from "./sections/RelatedServices";
import ProblemCategories from "./sections/ProblemCategories";
import ServiceArea from "./sections/ServiceArea";
import Faq from "./sections/Faq";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function EmergencyPlumbingPage() {
  return <div>
      <Header />
      <EmergencyHero />
      <Overview />
      <Triage />
      <EmergencySigns />
      <Diagnostics />
      <RelatedServices />
      <ProblemCategories />
      <ServiceArea />
      <Faq />
      <EmergencyCta />
      <Footer />
    </div>;
}